import React, { useEffect, useState } from 'react';
import { collection, getDoc, getDocs, doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';

function StudentAddCourse() {
    const [courses, setCourses] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [enrolledCourses, setEnrolledCourses] = useState([]);

    const navigate = useNavigate();


    const fetchEnrolledCourses = async () => {
        const user = auth.currentUser;
        if (user) {
            // Get the user's enrolled courses from the users collection
            const userDocRef = doc(db, "users", user.uid);
            const userSnapshot = await getDoc(userDocRef);
            if (userSnapshot.exists()) {
                const userCourses = userSnapshot.data().enrolledCourses || [];
                // Fetch the full details of each enrolled course
                const classesCollection = collection(db, "classes");
                const coursesSnapshot = await getDocs(classesCollection);
                const coursesList = coursesSnapshot.docs
                    .filter(course => userCourses.includes(course.id))
                    .map(course => ({ id: course.id, ...course.data() }));

                setEnrolledCourses(coursesList);

            }
        }
    };


    useEffect(() => {

        fetchEnrolledCourses();
    }, []);
    // Fetch courses from the classes collection
    useEffect(() => {
        const fetchCourses = async () => {
            const classesCollection = collection(db, "classes");
            const courseSnapshot = await getDocs(classesCollection);
            const coursesList = courseSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setCourses(coursesList);
           
        };

        fetchCourses();
    }, [db]);




    const handleAddCourse = async (courseId) => {
       
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, "users", user.uid);
            try {

                const userSnapshot = await getDoc(userDocRef);
                if (userSnapshot.exists()) {
                    const userCourses = userSnapshot.data().enrolledCourses || [];

                    // Check if the course is already added
                    if (userCourses.includes(courseId)) {
                        setErrorMessage("You have already added this course.");
                        setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
                        setSuccessMessage('');
                        return;
                    }
                    await updateDoc(userDocRef, {
                        enrolledCourses: arrayUnion(courseId)
                    });
                    fetchEnrolledCourses()
                    console.log(`These are my enrolled: ${enrolledCourses}`)
                    console.log(enrolledCourses)

                

                    setSuccessMessage("Course added successfully!");
                    setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
                }
            } catch (error) {
                console.error("Error adding course: ", error);
                setErrorMessage("An error occurred while adding the course.");
                setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
            }
        }
    };




    return (
        <Container className="bg-white p-4 shadow-sm rounded">
            <h2 className="custom-font">Add Available Courses</h2>
            {successMessage && (
                <div className="alert alert-success">
                    <strong>Success!</strong> {successMessage}
                </div>
            )}
            {errorMessage && (
                <div className="alert alert-danger">
                    <strong>Error!</strong> {errorMessage}
                </div>
            )}
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Department</th>
                        <th>Course Number</th>
                        <th>Subject</th>
                        <th>Instructor</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {courses.map(course => (
                        <tr key={course.id}>
                            <td>{course.name}</td>
                            <td>{course.abbreviatedName}</td>
                            <td>{course.subject}</td>
                            <td>{course.instructorName}</td>
                            <td>
                                <Button variant="outline-primary" className="ms-3 btn-dark-green" onClick={() => handleAddCourse(course.id)}>
                                    Add
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className="text-center mt-4">
                <Button variant="outline-primary" className="ms-3 btn-dark-green" onClick={() => navigate('/studentdashboard')}>
                    Back to Dashboard
                </Button>
            </div>
        </Container>
    );
}

export default StudentAddCourse;